import { Directive, Input, OnDestroy, TemplateRef, ViewContainerRef } from '@angular/core';
import { BreakpointObserver } from '@angular/cdk/layout';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { BreakpointState } from '@angular/cdk/layout/breakpoints-observer';

@Directive({
  selector: '[appMediaQuery]',
})
export class MediaQueryDirective implements OnDestroy {
  @Input() set appMediaQuery(query: string) {
    this.destroyed.next();

    setTimeout(() => {
      this.setListener(query);
    });
  }

  private hasView = false;

  private destroyed = new Subject<void>();

  constructor(
    private readonly viewContainer: ViewContainerRef,
    private readonly template: TemplateRef<any>,
    private readonly breakpointObserver: BreakpointObserver,
  ) {}

  private setListener(query: string) {
    this.breakpointObserver
      .observe([query])
      .pipe(takeUntil(this.destroyed))
      .subscribe((result: BreakpointState) => {
        if (result.matches && !this.hasView) {
          this.hasView = true;
          this.viewContainer.createEmbeddedView(this.template);
        }

        if (!result.matches && this.hasView) {
          this.hasView = false;
          this.viewContainer.clear();
        }
      });
  }

  ngOnDestroy(): void {
    this.destroyed.next();
    this.destroyed.complete();
  }
}
